export const namespaced = true;

export const state = {
  pendingTrips: [],
  profile: {}, //logged in user profile
  currentTravellerProfile: {}, //profile for designated traveler
  otherProfiles: {},
  travellers: {
    tripType: "business",
    bookFor: "user",
    others: [], //deprecated
    set: true,
  },
  unaccompaniedMinorAirlineDetails: [],
  accountNotes: [],
};

export const mutations = {
  //set active user profile
  ADD_PROFILE(state, payload) {
    state.profile = payload;
  },
  //set traveller profile
  SET_TRAVELLER_PROFILE(state, payload) {
    console.log("Setting traveller profile", payload);
    state.currentTravellerProfile = payload;
  },
  ADD_OTHER_PROFILE(state, payload) {
    let id = payload[0];
    let profile = payload[1];
    if (!state.otherProfiles[id]) {
      state.otherProfiles[id] = profile;
    }
  },
  EDIT_TRAVELLERS(state, payload) {
    state.travellers = payload;
  },
  UNACCOMPANIED_MINOR_AIRLINE_DETAILS(state, payload) {
    state.unaccompaniedMinorAirlineDetails = payload;
  },
  ADD_PAYMENT(state, payload) {
    state.currentTravellerProfile.paymentMethods.push(payload);
  },
  UPDATE_PAYMENT(state, payload) {
    const paymentMethods = state.currentTravellerProfile.paymentMethods;
  
    // Find the index of the payment method to update
    const index = paymentMethods.findIndex(method => method.id === payload.id);
  
    if (index !== -1) {
      // Remove the existing payment method
      paymentMethods.splice(index, 1);
    }
  
    // Add the updated payment method
    state.currentTravellerProfile.paymentMethods.push(payload);
  },

  // Account Notes mutations
  SET_ACCOUNT_NOTES(state, payload) {
    state.accountNotes = payload || [];
  },

  UPDATE_ACCOUNT_NOTE(state, { section, content, isActive }) {
    const existingNoteIndex = state.accountNotes.findIndex(note => note.section === section);

    if (existingNoteIndex !== -1) {
      // Update existing note
      state.accountNotes[existingNoteIndex] = {
        ...state.accountNotes[existingNoteIndex],
        content,
        isActive
      };
    } else {
      // Add new note
      state.accountNotes.push({
        section,
        content,
        isActive
      });
    }
  },

};

export const actions = {
  addPendingTrips(context) {
    context.commit(
      "bookTravel/CHANGE_MAIN_RESULT",
      {
        flight: {},
        car: {},
        hotel: {},
      },
      { root: true }
    );
  },
  //set active user profile
  addProfile(context, payload) {
    context.commit("ADD_PROFILE", payload);
  },
  addPayment(context, payload) {

    if (context.rootState.meetings.meetingInfo) {
      context.commit("meetings/ADD_PAYMENT_TO_MEETING_CONTACT", payload, {root: true});
    } else {
      context.commit("ADD_PAYMENT", payload);
    }
    
  },
  updatePayment(context, payload) {

    if (context.rootState.meetings.meetingInfo) {
      context.commit("meetings/UPDATE_PAYMENT_TO_MEETING_CONTACT", payload, {root: true}); //TODO
    } else {
      context.commit("UPDATE_PAYMENT", payload);
    }
    
  },
  unaccompaniedMinorAirlineDetails(context, payload) {
    context.commit("UNACCOMPANIED_MINOR_AIRLINE_DETAILS", payload);
  },
  addMeetingContactToProfile(context) {
    if (context.rootState.meetings.meetingInfo) {
      let contact = context.rootState.meetings.meetingInfo.contact;
      // Override the traveler's regular travel policy
      // with the meeting specific travel policy
      contact.travelPolicyId =
        context.rootState.meetings.meetingInfo.travelPolicyId;
      contact.travelPolicy =
        context.rootState.meetings.meetingInfo.travelPolicy;
      context.commit("SET_TRAVELLER_PROFILE", contact);
      console.log('done loading profile from meeting contact.')
    }
  },

  // Account Notes actions
  setAccountNotes(context, notes) {
    context.commit('SET_ACCOUNT_NOTES', notes);
  },

  updateAccountNote(context, noteData) {
    context.commit('UPDATE_ACCOUNT_NOTE', noteData);
  },

  async fetchAccountNotes(context) {
    try {
      const accountId = context.state.currentTravellerProfile?.account?.id;
      if (!accountId) {
        console.warn('No account ID available for fetching notes');
        return;
      }

      // Import NotesService dynamically to avoid circular dependencies
      const NotesService = (await import('@/services/NotesService.js')).default;
      const notesService = new NotesService(this._vm.$app);

      const result = await notesService.getAllNotes(accountId);

      if (result && result.data && result.data.length > 0) {
        const accountData = result.data[0];
        if (accountData && accountData.notes) {
          context.commit('SET_ACCOUNT_NOTES', accountData.notes);
        }
      }
    } catch (error) {
      console.error('Error fetching account notes:', error);
      // Don't throw error to prevent blocking the UI
    }
  },
};

export const getters = {

  getCurrentTravellerProfile(state, getters, rootState){
    return state.currentTravellerProfile;
  },

  getTravellers(state) {
    return state.travellers;
  },

  getLoggedInUserProfile(state) {
    return state.profile;
  },

  // Account Notes getters
  getAccountNotes(state) {
    return state.accountNotes;
  },

  getAccountNoteBySection: (state) => (section) => {
    return state.accountNotes.find(note => note.section === section) || null;
  },

  getActiveAccountNoteBySection: (state) => (section) => {
    const note = state.accountNotes.find(note => note.section === section);
    return (note && note.isActive) ? note : null;
  },

  getUserDefaultCurrency(state) {
    return state.currentTravellerProfile?.defaultCurrency || 'USD';
  },

  getUserCurrencyInfo(state, getters) {
  const currencyCode = getters.getUserDefaultCurrency;

    // Get the symbol
    const symbol = (0).toLocaleString("en-US", {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).replace(/\d/g, '').trim();

    // Get the full currency name
    const nameFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "name",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });

    // Format "2", strip it out and be left with the currency name in plural
    const name = nameFormatter.format(2).replace(/\d/g, '').trim();

    return {
      code: currencyCode,
      symbol: symbol || currencyCode,
      name: name
    };
}

};
